import { createI18n } from 'vue-i18n'

export default () => createI18n({
  locale: document.documentElement.lang,
  fallbackLocale: 'en',
  messages: {
    en: {
      name: "Name:",
      email: "Email:",
      subject: "Subject:",
      comments: "Comments:",
      sending: "Sending...",
      sendmessage: "Send Message",
      messagesent: "Message Sent...",
      errorsent: "Failed to send message...",
      projectType: "Project Type:",
      selectOne: "Select One",
      coaching: "Coaching",
      training: "Training",
      architecture: "Architectural Design",
      codeReview: "Code Review",
      other: "Other",
      timeframe: "Timeframe:",
      budget: "Budget:",
      message: "Message:",
      sendQuoteRequest: "Send Quote Request",
      quoteSent: "Quote Sent",
      failedQuote: "Failed to send quote...please call +1 404 227 3030",
      search: "Search",
      searching: "Searching",
      errorSearching: "Error Searching",
      searchHere: "Search Here",
      page: "Page",
      results: "Results",
      getMoreResults: "Get More Results",
    },
    nl: {
      name: "Naam:",
      email: "E-mail:",
      subject: "Onderwerp:",
      comments: "Verklarende Aantekening:",
      sending: "Verzenden...",
      sendmessage: "Bericht versturen",
      messagesent: "Bericht verzonden...",
      errorsent: "Kan bericht niet verzenden...",
      projectType: "Projecttype:",
      selectOne: "Selecteer één",
      coaching: "Coachen",
      training: "Opleiding",
      architecture: "Architectonisch Ontwerp",
      codeReview: "Codebeoordeling",
      other: "Ander",
      timeframe: "Tijdsbestek:",
      budget: "Begroting:",
      message: "Bericht:",
      sendQuoteRequest: "Offerteaanvraag Versturen",
      quoteSent: "Citaat Verzonden",
      failedQuote: "De offerte kon niet worden verzonden. Bel alstublieft +1 404 227 3030",
      search: "Zoekopdracht",
      searching: "Zoeken",
      errorSearching: "Fout bij zoeken",
      searchHere: "Zoek Hier",
      page: "Pagina",
      results: "Resultaten",
      getMoreResults: "Krijg Meer Resultaten",
    }
  }
});